"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Implementing null object pattern
var Null = /** @class */ (function () {
    function Null() {
    }
    Null.prototype.init = function (actionCallback) {
        return;
    };
    Null.prototype.toString = function () {
        return 'Unknown trigger called';
    };
    return Null;
}());
exports.default = Null;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTnVsbC5qcyIsInNvdXJjZVJvb3QiOiJzcmMvIiwic291cmNlcyI6WyJzcmMvbGliL3NlcnZpY2VzL3RyaWdnZXJzL051bGwudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFFQSxtQ0FBbUM7QUFDbkM7SUFBQTtJQVFBLENBQUM7SUFQRyxtQkFBSSxHQUFKLFVBQU0sY0FBNkI7UUFDL0IsT0FBTTtJQUNWLENBQUM7SUFFRCx1QkFBUSxHQUFSO1FBQ0ksT0FBTyx3QkFBd0IsQ0FBQTtJQUNuQyxDQUFDO0lBQ0wsV0FBQztBQUFELENBQUMsQUFSRCxJQVFDIn0=